module.exports = __webpack_public_path__ + "static/img/param_1.19e06a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/param_1.png
// module id = P7oV
// module chunks = 1